<template>
    <div class="my_order_wrapper">
        <van-tabs sticky
            v-model="active"
            color="#28CC77"
            line-height="0.06rem"
            title-active-color="#28CC77"
            title-inactive-color="#666"
            offset-top="0rem"
        >
            <van-tab title="待生效" title-style="font-size:0.3rem"></van-tab>
            <van-tab title="保障中" title-style="font-size:0.3rem"></van-tab>
            <van-tab title="待续保" title-style="font-size:0.3rem"></van-tab>
        </van-tabs>
        <div class="list">
            <div v-for="(item, index) in itemMsg" :key="index">
                <my-order :item='item' :active='active'></my-order>
            </div>
        </div>
    </div>
</template>

<script>
// import Vue from 'vue';
import { Tab, Tabs } from 'vant';
import './MyOrder.less'
import MyOrder from './../../components/MyOrderItem'

export default {
    name: 'myOrder',
    data(){
        return{
            active: 0,
            itemMsg:[
                {
                    type: '雇主责任险',
                    name: '张三',
                    orderId: '8G201999202020202020',
                    orderTime: '2020.08.10-2021.08.09',
                    price: '60',
                    createTime: '2020-08-09  22:14:36'
                },
                {
                    type: '雇主责任险',
                    name: '张三',
                    orderId: '8G201999202020202020',
                    orderTime: '2020.08.10-2021.08.09',
                    price: '60',
                    createTime: '2020-08-09  22:14:36'
                },
                {
                    type: '雇主责任险',
                    name: '张三',
                    orderId: '8G201999202020202020',
                    orderTime: '2020.08.10-2021.08.09',
                    price: '60',
                    createTime: '2020-08-09  22:14:36'
                }
            ]
        }
    },
    components: {
        'van-tab': Tab,
        'van-tabs': Tabs,
        'my-order': MyOrder
    },
    methods: {

    }
}
</script>

<style>

</style>